import LegalLayout from "./LegalLayout";
import ComingSoon from "./ComingSoon";

export default function Refunds() {
  return (
    <LegalLayout title="Refunds & Cancellation" kicker="Legal">
      <ComingSoon
        blurb="Our refund and cancellation policy is on its way. You'll be able to view it here soon."
        testid="legal-refunds-coming-soon"
      />
    </LegalLayout>
  );
}
